import { useTextDomainContext } from "../../providers";
import React, { useContext, useEffect, useState } from "react";
import { ModalBox } from "./ModalBox";
import { Grid, TextField, Tooltip, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import PropTypes from "prop-types";
import { LoadingButton } from "@mui/lab";
import { enqueueSnackbar } from "notistack";
import {
  useDeletePublicToken,
  useGeneratePublicToken,
  useGetPublicToken,
} from "../../../hooks";

export const ApiKeyModal = (props) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const [apiKey, setApiKey] = useState("");
  const loading = false;
  const readOnly = true;

  const { generatePublicToken, loadingGenerate } = useGeneratePublicToken(
    (token) => {
      if (token) {
        setApiKey(token);
      }
    },
    (error) => {
      enqueueSnackbar(error?.message, {
        variant: "error",
      });
    },
  );

  const { token } = useGetPublicToken();

  const { delete: deletePublicToken, deleting } = useDeletePublicToken();

  useEffect(() => {
    if (token) {
      setApiKey(token);
    } else {
      setApiKey("");
    }
  }, [token]);

  //#region Handlers
  const onClickToken = () => {
    navigator.clipboard.writeText(apiKey).then(() => {
      enqueueSnackbar(gettext("Copied to clipboard"), {
        variant: "info",
      });
    });
  };

  const handleGenerateToken = () => {
    generatePublicToken();
  };
  const handleDeleteToken = () => {
    deletePublicToken();
    setApiKey("");
  };
  //#endregion Handlers

  return (
    <ModalBox open={props.open} handleClose={props.handleClose}>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.grey[50],
          p: 4,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            pb: 3,
          }}
        >
          <Typography variant="h4">{gettext("API Key")}</Typography>
        </Box>
        <Box>
          <Stack
            spacing={2}
            sx={{
              height: "100%",
            }}
          >
            <Grid item xs={12}>
              <Tooltip title={gettext("Click to copy")}>
                <TextField
                  placeholder={gettext("API key")}
                  multiline
                  // disabled
                  // rows={2}
                  // minRows={4}
                  fullWidth
                  value={apiKey}
                  onClick={onClickToken}
                  inputProps={{
                    readOnly: Boolean(readOnly),
                    // disabled: Boolean(readOnly),
                  }}
                />
              </Tooltip>
            </Grid>
            <Grid item xs={12} textAlign="center">
              {!apiKey && (
                <LoadingButton
                  variant="contained"
                  loading={loadingGenerate}
                  fullWidth
                  onClick={handleGenerateToken}
                  // disabled={saveButtonDisabled}
                >
                  {gettext("Generate API Key")}
                </LoadingButton>
              )}
              {apiKey && (
                <LoadingButton
                  variant="contained"
                  color="error"
                  loading={loading}
                  fullWidth
                  onClick={handleDeleteToken}
                  disabled={deleting}
                >
                  {gettext("Delete API Key")}
                </LoadingButton>
              )}
            </Grid>
          </Stack>
          {/*<ChangePasswordForm handleClose={props.handleClose}/>*/}
        </Box>
      </Box>
    </ModalBox>
  );
};

ApiKeyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
